import React from "react";
import Logo from "components/Logo";

import { Navigate } from "react-router-dom";

const Login = () => {

const pharmaforceString = sessionStorage.getItem("pharmaforce");
if (pharmaforceString) {
  try {
    const pharmaforce = JSON.parse(pharmaforceString);
    if (pharmaforce.profile) {
      console.log("Profile:", pharmaforce.profile);
      const roles = pharmaforce.profile.roles;
      if(roles.includes("SUPADM") || roles.includes("RCMADM")){
             return <Navigate to="/dashboard" />;
      }
       else{
         return <Navigate to="/claims-manager" />;
  }
      
    } else {
      console.error("Profile is undefined.");
    }
  } catch (error) {
    console.error("Error parsing pharmaforce data:", error);
  }
}

  return (
    <div className="h-90vh d-flex align-items-center justify-content-center">
      <div className="text-center">
        <Logo height={50} />
      </div>
    </div>
  );
};

export default Login;
